import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission } from '../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.SOURCES, permission: Permission.UPDATE });
    context.validatePermissions({ isAllowed, preload });
  },
});
